import React, {Component} from 'react';
import Actionbar from "../Common/Actionbar";
import Toast from '../Common/Toast';
import API from '../../services/API';
import {toast} from "react-toastify";
import EmptyPic from "../../assets/images/emptypic.png";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {
    faCheck
} from '@fortawesome/free-solid-svg-icons'
import BlacklistHistory from "./BlacklistHistory";

class BlackListHistoryPage extends Component {
    state={
        content : '',
        avatar: null,
        last_name: '',
        first_name: '',
        mobile: '',
        national_id: '',
        province: '',
        tel: '',
        description: '',
        city: '',
        email: '',
        file: null,
        pic: EmptyPic,
        provinces: [],
        cities: [],
        province_id: 0,
        city_id: 0,
        buttonStatus: "",
        buttonText : "ثبت تغییرات",
        loading: "d-none",
    }
    onFileChange = (event) => {
        let reader = new FileReader()
        reader.readAsDataURL(event.target.files[0])
        reader.onload = () => {
            this.setState({
                pic: reader.result,
                file: event.target.files[0]
            })
        };

    }
    onInputChange = (event) => {
        const inputName = event.target.name;
        const inputValue = event.target.value;
        this.setState({[inputName]: inputValue});

    }
    onProvinceChange = (event) => {
        const province_id = event.target.value;
        this.setState({province_id});
        API.cities(province_id)
            .then((response) => {
                this.setState({cities: response.results.cities})
            })
    }
    onButtonClick = () => {
 /*       if(this.state.last_name.length < 3) {
            toast.error('لطفا نام خانوادگی را درست وارد کنید');
            return false
        }*/
        const buttonText  = "";
        const  loading = "d-inline-block";
        const buttonStatus = "disabled";
        this.setState({buttonText,loading,buttonStatus });
        const formData = new FormData();
        const file = this.state.file;
        if (file)
            formData.append('avatar', file);
        formData.append('last_name', this.state.last_name);
        formData.append('first_name', this.state.first_name);
        formData.append('national_id', this.state.national_id);
        formData.append('tel', this.state.tel);
        if(this.state.email)
            formData.append('email', this.state.email);
        formData.append('province_id', this.state.province_id);
        formData.append('city_id', this.state.city_id);
        formData.append('phone_specification', navigator.userAgent);

        API.updateProfile(formData)
            .then((response) => {
                toast.success(response.user_message);
                const buttonText  = "ثبت تغییرات";
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });
            })
            .catch((error) => {

                toast.error(error.response.data.user_message);
                const buttonText  = "ثبت تغییرات";
                const  loading = "d-none";
                const buttonStatus = "";
                this.setState({buttonText,loading,buttonStatus });

            });
    }


    render() {
        return (
            <React.Fragment>
                <Toast/>
                <Actionbar noBack={0} title='تاریخچه لیست سیاه'  />
                <BlacklistHistory history={this.state.black_list_history} />

            </React.Fragment>
        );
    }
    componentDidMount = () => {

        API.profile()
            .then((response) => {
                this.setState(response.results.user)
                if (response.results.user.province) {
                    this.setState({
                        province_id: response.results.user.province.id,
                        city_id: response.results.user.city.id
                    })
                }

            })
        API.provinces(83)
            .then((response) => {
                this.setState({provinces: response.results.provinces})
            })

        API.cities(this.state.province_id)
            .then((response) => {
                this.setState({cities: response.results.cities})
            })

    }
}

export default BlackListHistoryPage;